import { useFieldContext } from '../field/field-context'
import { TextInput } from '../text-input'
import { useFormFieldContext } from './form-context'

export default function TextInputFormField(props: TextInput.Props) {
  const field = useFormFieldContext<string>()
  const { size } = useFieldContext()
  return (
    <TextInput
      defaultValue={field.options.defaultValue}
      id={field.name}
      name={field.name}
      size={size}
      value={field.state.value}
      onChange={(e) => field.setValue(e.currentTarget.value)}
      {...props}
    />
  )
}
